import { Component, OnInit } from '@angular/core';
import {ApiService} from "../../../../services/api.service";
import {NzModalRef} from "ng-zorro-antd/modal";
import {SubscriptionService} from "../../../../services/subscription.service";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-end-trial-modal',
  templateUrl: './end-trial-modal.component.html',
  styleUrls: ['./end-trial-modal.component.scss']
})
export class EndTrialModalComponent implements OnInit {

  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $trialEnd: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public api: ApiService,
    public subscriptionService: SubscriptionService,
    private modal: NzModalRef) { }

  ngOnInit(): void {
  }

  endTrialEarly(){

    this.$loading.next(true);
    this.subscriptionService.endTrialEarly().then((res)=>{

      this.subscriptionService.checkPublicSubscriptionStatus().then((SubscriptionStatus) =>{
        this.subscriptionService.currentPaymentStatusSubject.next(SubscriptionStatus);

        this.subscriptionService.getPackageAndBalance().then((res)=>{
          this.subscriptionService.currentPackage.next(res.Package);
          this.subscriptionService.currentFeatures.next(res.MetaData);
          this.$loading.next(false);
          this.$trialEnd.next(true);
        })

      });

    })

  }

  closeModal(){
    this.modal.close(false);
  }

}
